<template>
  <div v-if="hasError" class="toast toast-error" role="alert">
    <button
      v-on:click="clearError"
      class="btn btn-clear float-right"
      aria-label="Clear error"
    ></button>
    Error:
    <a v-on:click="viewDetails" href="#">
      {{ errorMessage }}
    </a>
  </div>
</template>

<script>
import IOStore from "../stores/IOStore";
import ConfigStore from "../stores/ConfigStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";

export default {
  name: "ErrorToast",
  data() {
    return { IOStore };
  },
  computed: {
    errorType() {
      if (IOStore.methods.error()) {
        return "io";
      } else if (PFStore.methods.error()) {
        return "pf";
      } else if (OPFStore.methods.error()) {
        return "opf";
      } else {
        return "";
      }
    },
    hasError() {
      return this.errorType.length !== 0;
    },
    errorMessage() {
      switch (this.errorType) {
        case "io":
          return IOStore.methods.error();
        case "pf":
          return PFStore.methods.error();
        case "opf":
          return OPFStore.methods.error();
      }
      return "";
    }
  },
  methods: {
    viewDetails() {
      ConfigStore.data.config.outputTab = this.errorType;
    },
    clearError() {
      IOStore.methods.error("");
      PFStore.methods.error("");
      OPFStore.methods.error("");
    }
  }
};
</script>
